import { defineMessages } from "react-intl";

export const messages = defineMessages({
  consentTabLabel: {
    id: "settings.tab.consent.label",
    defaultMessage: "Consent",
    description: "Label for tab consent",
  },
  privacyPolicyTabLabel: {
    id: "settings.tab.privacyPolicy.label",
    defaultMessage: "Privacy policy",
    description: "Label for tab privacy policy",
  },
});
